import React from "react";
import { useTranslation } from "react-i18next";

const TrackStepsPreview = (props) => {
  const { t } = useTranslation();
  let status = props.status;
  return (
    <>
      <div className="row">
        <div className="steps">
          <div
            className={
              "step " +
              (status === 1 ? "active" : status > 1 ? "skipped" : null)
            }
          >
            <div className="number">1</div>
            <div className="text-wrapper position-relative">
              <div className="text">{t("registered")}</div>
            </div>
          </div>
          <div
            className={
              "step " +
              (status === 2 ? "active" : status > 1 ? "skipped" : null)
            }
          >
            <div className="number">2</div>
            <div className="text-wrapper position-relative">
              <div className="text">{t("considered")}</div>
            </div>
          </div>

          <div className={"step " + (status === 3 ? "active" : null)}>
            <div className="number">3</div>
            <div className="text-wrapper position-relative">
              <div className="text">{t("closed")}</div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <h2>
          {t("complaintNumber")} <strong>{props.complainNumber}</strong>
        </h2>
        {props.status === "requested" && (
          <p>
            {t("statusRegistered")}
          </p>
        )}
        {props.status === "examined" && (
          <p>
            {t("statusConsidered")}
          </p>
        )}
        {(props.status === "negative" || props.status === "positive") && (
          <p>
            {t("statusClosed")}
          </p>
        )}
      </div>
    </>
  );
};

export default TrackStepsPreview;
